import React from 'react';

export const InfoBalloon: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
    <svg viewBox='0 0 16.25 16.25' {...props}>
      <g transform='translate(-4.875 -4.675)' fill='currentColor'>
        <path
          d='M21,12.569A8,8,0,1,0,12.929,20.8H21ZM12.538,9.9a.728.728,0,0,1,.5-.16.76.76,0,0,1,.5.16.552.552,0,0,1,.2.444.606.606,0,0,1-.2.444.728.728,0,0,1-.5.16.76.76,0,0,1-.5-.16.552.552,0,0,1-.2-.444A.5.5,0,0,1,12.538,9.9Zm1.618,5.8H11.933v-.3c.089-.036.16-.071.249-.107s.178-.053.284-.089V12.231l-.533-.071v-.3a1.22,1.22,0,0,1,.3-.089c.124-.036.249-.053.391-.089.142-.018.267-.053.391-.071a2.739,2.739,0,0,1,.338-.036h.267V15.2c.107.036.2.053.284.089s.16.071.249.107Z'
        />
      </g>
    </svg>
  )
;
